import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { transformMealConfiguration } from './meal.dto';
import { TMealConfiguration, TMenhirMealConfiguration } from './meal.types';

export const getMealConfiguration = (): Promise<TMealConfiguration> =>
  menhirClient
    .get<
      null,
      TMenhirMealConfiguration
    >(MENHIR_ENDPOINTS.EMPLOYEE.MEAL.CONFIG.ROOT)
    .then((mealConfiguration) => transformMealConfiguration(mealConfiguration));

export const activateMealSinglePayment = (
  paymentMethodId: string
): Promise<void> =>
  menhirClient.post(MENHIR_ENDPOINTS.EMPLOYEE.MEAL.CONFIG.SINGLE_TRANSACTION, {
    payment_method_id: paymentMethodId,
  });
